import { render, staticRenderFns } from "./WebAddGroup.vue?vue&type=template&id=3a28e180&"
import script from "./WebAddGroup.vue?vue&type=script&lang=js&"
export * from "./WebAddGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports